export default __webpack_public_path__ + "static/media/navigate-sharp-round.64f1a00e.svg";